import { useQuery } from '@tanstack/react-query';

import { QuoteSetupPresetSearchRequestQuery, QuoteSetupPresetSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { quoteSetupPresetQueryKey } from '@services/quotes/quoteSetupPreset/keys';

const getQueryParams = (params: QuoteSetupPresetSearchRequestQuery) => {
  const { sort, pageLimit, pageOffset, slug, offeringId, includeDeleted, brokerageId } = params;
  const query = new URLSearchParams();

  if (sort) {
    query.append('sort', sort);
  }

  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }

  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  if (slug) {
    query.append('slug', String(slug));
  }

  if (includeDeleted === true || (includeDeleted as any) === 'true') {
    query.append('includeDeleted', includeDeleted ? 'true' : 'false');
  }

  if (offeringId) {
    query.append('offeringId', String(offeringId));
  }

  if (brokerageId) {
    query.append('brokerageId', String(brokerageId));
  }

  return query.toString();
};

export const useSearchQuoteSetupPreset = (params: QuoteSetupPresetSearchRequestQuery, enabled = false) => {
  const client = useClient();

  const query = getQueryParams({ ...params });

  const result = useQuery({
    enabled: enabled,
    queryKey: quoteSetupPresetQueryKey.searchWithParams(params),
    queryFn: () => client.get(`quote-setup-preset?${query}`).json<QuoteSetupPresetSearchResponse>(),
    refetchOnWindowFocus: false,
  });
  return {
    ...result,
    quotePresets: result.data?.items as QuoteSetupPresetSearchResponse['items'],
  };
};
